module.exports = __webpack_public_path__ + "static/media/1_evenement.1791d45e.jpg";